/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LookupKeyEnum,
    LookupKeyEnumFromJSON,
    LookupKeyEnumFromJSONTyped,
    LookupKeyEnumToJSON,
} from './LookupKeyEnum';

/**
 * 
 * @export
 * @interface CampaignLinkResolveDto
 */
export interface CampaignLinkResolveDto {
    /**
     * 
     * @type {string}
     * @memberof CampaignLinkResolveDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignLinkResolveDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignLinkResolveDto
     */
    affiliateCode: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CampaignLinkResolveDto
     */
    validTo: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignLinkResolveDto
     */
    isActive: boolean;
    /**
     * 
     * @type {LookupKeyEnum}
     * @memberof CampaignLinkResolveDto
     */
    preferredLookupKey: LookupKeyEnum | null;
    /**
     * 
     * @type {Array<LookupKeyEnum>}
     * @memberof CampaignLinkResolveDto
     */
    allowedLookupKeys: Array<LookupKeyEnum>;
}

export function CampaignLinkResolveDtoFromJSON(json: any): CampaignLinkResolveDto {
    return CampaignLinkResolveDtoFromJSONTyped(json, false);
}

export function CampaignLinkResolveDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampaignLinkResolveDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'slug': json['slug'],
        'affiliateCode': json['affiliateCode'],
        'validTo': (json['validTo'] === null ? null : new Date(json['validTo'])),
        'isActive': json['isActive'],
        'preferredLookupKey': LookupKeyEnumFromJSON(json['preferredLookupKey']),
        'allowedLookupKeys': ((json['allowedLookupKeys'] as Array<any>).map(LookupKeyEnumFromJSON)),
    };
}

export function CampaignLinkResolveDtoToJSON(value?: CampaignLinkResolveDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'slug': value.slug,
        'affiliateCode': value.affiliateCode,
        'validTo': (value.validTo === null ? null : value.validTo.toISOString()),
        'isActive': value.isActive,
        'preferredLookupKey': LookupKeyEnumToJSON(value.preferredLookupKey),
        'allowedLookupKeys': ((value.allowedLookupKeys as Array<any>).map(LookupKeyEnumToJSON)),
    };
}

